module.exports = __webpack_public_path__ + "img/tianyuan.08ec02f7.jpg";